"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useStrategizeValue = void 0;
const react_1 = require("react");
const hooks_1 = require("../../../../../client/hooks");
const values_1 = require("../../../../../client/values");
const hooks_2 = require("../../../../../hooks");
const use_history_changes_hook_1 = require("../../../../../hooks/use-history-changes.hook");
const hooks_3 = require("../../../../../../hooks");
const localization_1 = require("../../../../../../localization");
const store_1 = require("../../../../../../store");
const useStrategizeValue = ({ attributeName }) => {
    const { addSuccess, addError } = (0, hooks_3.useNotification)();
    const { formatMessage: t } = (0, localization_1.useLocalization)();
    const { addValuesToSeveralNodes } = (0, values_1.useAddValuesToSeveralNodes)();
    const selectedStrategyNodePath = (0, store_1.useSelectedTreeNodePath)();
    const { handleAddNewItemsToHistory } = (0, use_history_changes_hook_1.useHistoryChanges)();
    const { refetchQueriesOnStrategyValueChange } = (0, hooks_1.useRefetchQueries)();
    const selectedTreeNode = (0, hooks_2.useSelectedTreeNode)();
    const { id: selectedTreeNodeId, title: selectedTreeNodeTitle } = selectedTreeNode !== null && selectedTreeNode !== void 0 ? selectedTreeNode : {};
    const onStrategizeValue = (0, react_1.useCallback)((newValue) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const newAttributeData = {
                name: attributeName,
                values: [{ name: newValue }],
            };
            // TODO: value will be also added to all child nodes -> find a way to update cache
            yield addValuesToSeveralNodes([newAttributeData], [selectedTreeNodeId], { includeDescendants: true });
            yield refetchQueriesOnStrategyValueChange({ selectedTreeNodeId, attributeName });
            handleAddNewItemsToHistory(newAttributeData, [selectedStrategyNodePath]);
            addSuccess(t({
                key: 'VALUE_STRATEGIZED',
                values: {
                    value: newValue,
                    attribute: attributeName,
                    category: selectedTreeNodeTitle,
                },
            }));
        }
        catch (err) {
            addError(t({
                key: 'ADD_ENTITY_ERROR',
                values: {
                    count: 1,
                    entity: String(t({ key: 'VALUE' })).toLowerCase(),
                },
            }));
        }
    }), [
        attributeName,
        selectedTreeNodeId,
        addValuesToSeveralNodes,
        addSuccess,
        t,
        handleAddNewItemsToHistory,
        selectedStrategyNodePath,
        addError,
        refetchQueriesOnStrategyValueChange,
        selectedTreeNodeTitle,
    ]);
    return {
        onStrategizeValue,
    };
};
exports.useStrategizeValue = useStrategizeValue;
